// test630
(630 && 0);
